import { ApplicationRouteURL, WeGoConfig } from './../../shared/config';
import { BookingOverview } from './../../booking/models/booking-overview.model';
import { SearchBookingModel } from './../../booking/models/search-booking.model';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { AuthService } from './../../shared/models/auth.service';
import { Router } from '@angular/router';
import { TNCAcceptanceMoment } from '../../shared/models/enum-helper';

@Component({
  selector: 'wego-confirm-booking-driver',
  template: require('../views/confirm-booking-driver.component.html'),
  styles: [`
    span.label.label-default{
      font-size: 13px;
      line-height: 35px;
      background-color: #eeeeee;
      color: #2BA2AA;
      margin-right: 5px;
    }
    
    span.label.label-default.text-success{
      color: #3c763d;
    }
    
    span.label.label-default.text-danger{
      color: #a94442;
    }
          `
  ]
})
export class ConfirmBookingDriverComponent implements OnInit {
  @Input('BookingOverview') bookingOverview: BookingOverview;
  @Input('searchBookingModel') searchBookingModel: SearchBookingModel;
  @Input('BookingRemarks') bookingRemarks: string;
  @Output('OnConfirmBooking') onConfirmBooking = new EventEmitter();
  @Output('OnCancelBooking') onCancelBooking = new EventEmitter();

  @ViewChild("termsConditionModel") public termsConditionModel: any;

  constructor(private locationService: Location, private router: Router
    , private authService: AuthService) { }

  ngOnInit() { }

  private OnConfirmBooking($event: any) {
    if (!this.searchBookingModel.isRecurring) {
      this.termsConditionModel.show([TNCAcceptanceMoment.MAKE_BOOKING], this.searchBookingModel.bookingMasterHashId, '', TNCAcceptanceMoment.MAKE_BOOKING);
    } else {
      this.onConfirmBooking.emit({ BookingRemarks: this.bookingRemarks });
    }
  }

  public AllTncAccepted() {
    this.onConfirmBooking.emit({ BookingRemarks: this.bookingRemarks });
  }

  public TncRejected() {
    this.OnCancelBooking({ BookingRemarks: this.bookingRemarks });
  }

  private OnCancelBooking($event: any) {

    this.onCancelBooking.emit($event);

    let urlData = this.authService.GetURL(ApplicationRouteURL.URL_DASHBOARD_PAGE);

    this.router.navigate([urlData]);
  }

  public GetImageURL(imagePath: string) {
    return WeGoConfig.API_SERVER_URL + imagePath;
  }

  public GroupByCategory(vehicleAttributeList: any) {
    if (vehicleAttributeList) {
      let prop = 'vehicleAttributeCategoryName';
      return vehicleAttributeList.reduce(function (groups: any, item: any) {
        let val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        groups[val] = groups[val].sort((obj1: any, obj2: any) => {
          if (obj1.attributeName > obj2.attributeName) {
            return 1;
          }

          if (obj1.attributeName < obj2.attributeName) {
            return -1;
          }
          return 0;
        });
        return groups;
      }, {});
    } else {
      return {};
    }
  }

  public KeyOfObject(obj: any) {
    return Object.keys(obj);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking-driver/components/confirm-booking-driver.component.ts